import { render } from "./TeinteDetails.vue?vue&type=template&id=056f11ae&ts=true"
import script from "./TeinteDetails.vue?vue&type=script&lang=ts"
export * from "./TeinteDetails.vue?vue&type=script&lang=ts"

import "./TeinteDetails.vue?vue&type=style&index=0&id=056f11ae&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Digithia/app/internal/coprodex-color/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__